var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 62.5,
    fill: "#F0FDF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 49.5,
    fill: "#DEF7DC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 40.5,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 62.3571L58.9667 74.5L79.5 54.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.def49d73b4ccaf8378efabb3a4cac651.svg";
export { ForwardRef as ReactComponent };